import { FunctionComponent } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

import { Button } from '@kanda-libs/ks-design-library';

export interface LinkMenuButtonProps {
  text: string;
  path: string;
}

export const LinkMenuButton: FunctionComponent<LinkMenuButtonProps> = function (
  props: LinkMenuButtonProps,
) {
  return (
    <Button.Text
      id={props.path}
      variant="ghost"
      onClick={() => {
        window.location.href = props.path;
      }}
      label={props.text}
    />
  );
};

export interface LinkProps {
  to: string;
  children?: JSX.Element;
  className?: string;
}

const Link: FunctionComponent<LinkProps> = ({ ...props }) => {
  return <ReactRouterLink {...props} />;
};

export default Link;
